
export function fbqAddToCart(product) {
  if (typeof window.fbq !== 'function') return;
  window.fbq('track', 'AddToCart', {
    content_name: product.name,
    content_ids: [product.id],
    content_type: 'product',
    value: product.minPrice,
    currency: 'BRL'
  });
}

export function fbqInitiateCheckout() {
  if (typeof window.fbq !== 'function') return;
  window.fbq('track', 'InitiateCheckout');
}

export function fbqPurchase(value) {
  if (typeof window.fbq !== 'function') return;
  window.fbq('track', 'Purchase', {
    value,
    currency: 'BRL'
  });
}